import { Icon } from '../components/Icon';
import { PageTitle } from '../layout/PageTitle';

const STEPS = [
  {
    n: '1 · KONTROLA',
    title: 'Pravidelný request na stránku',
    text: 'Zaznamená sa čas, HTTP status, latencia a prípadná chyba. Jeden riadok na kontrolu (UptimeCheck).',
  },
  {
    n: '2 · DENNÝ SÚHRN',
    title: 'Rollup na jeden riadok za deň',
    text: 'Pomer dostupnosti, sekundy výpadku, počet incidentov (UptimeDay). Bez neho by 60 dní × 30 stránok znamenalo státisíce riadkov na jedno vykreslenie.',
  },
  {
    n: '3 · PRUH',
    title: '60 dní na jeden pohľad',
    text: 'Kreslí sa z denných súhrnov, nikdy zo surových kontrol, takže je okamžitý.',
  },
];

/** Prázdna obrazovka dostupnosti podľa prototypu — v1 len miesto, meranie príde vo v2. */
export function UptimePage() {
  return (
    <>
      <PageTitle title="Dostupnosť" sub="Vlastné meranie · pripravuje sa vo v2" />

      <div className="note border-l-2 border-l-brand">
        <Icon name="info" size={16} className="mt-px shrink-0 text-brand" />
        <div>
          <div className="mb-1 text-[12.5px] font-semibold">Pripravuje sa vo v2</div>
          <div className="hint">
            Dostupnosť si budeme merať <strong className="font-semibold text-dim">sami</strong> — nejde o napojenie na
            cudziu službu. Vo v1 je tu len miesto v navigácii, aby sa neskôr nemenila štruktúra aplikácie.
          </div>
        </div>
      </div>

      <section className="card flex flex-col gap-5 px-[26px] py-6">
        <div>
          <div className="card-t">Ako to bude fungovať</div>
          <div className="hint mt-1.5">Tri kroky, z ktorých každý rieši inú vec.</div>
        </div>
        <div className="grid3">
          {STEPS.map((s) => (
            <div key={s.n} className="flex flex-col gap-[7px]">
              <span className="font-mono text-[11px] tracking-[.6px] text-brand">{s.n}</span>
              <div className="text-[13px] font-medium">{s.title}</div>
              <div className="hint">{s.text}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="note">
        <Icon name="warn" size={16} className="mt-px shrink-0 text-sev-high" />
        <div>
          <div className="mb-1 text-[12.5px] font-semibold">Dva dôsledky, ktoré treba vyriešiť pred v2</div>
          <div className="hint">
            Vlastné meranie dáva zmysel len ak aplikácia beží{' '}
            <strong className="font-semibold text-dim">nepretržite</strong> — kým beží lokálne, dáta budú mať diery.
            A jeden uzol nevie rozlíšiť „stránka je dole" od „naša sieť je dole", takže pred zápisom výpadku treba
            overiť vlastnú konektivitu.
          </div>
        </div>
      </div>
    </>
  );
}
